import type { MarketVariants } from '@/lib/i18n'

export type Slide9BeRudeCopy = {
  heading: string
  body: string
  cta: string
}

// Canonical US. "Self-Defense" auto-spells to "Self-Defence" on the Qatar face.
export const copy: MarketVariants<Slide9BeRudeCopy> = {
  US: {
    heading: 'Chapter 4 complete.',
    body:
      'Remember: you don’t need to decide on the spot. If you notice secrecy, pressure, unusual payments, or a request for access, stop and verify through a channel you choose. Talk to someone you trust before you act.',
    cta: 'Start Chapter 5: Digital Self-Defense',
  },
  ar: {
    heading: 'اكتمل الفصل 4.',
    body:
      'تذكّر: لست مضطراً إلى اتخاذ القرار في اللحظة نفسها. إذا لاحظت سرية أو ضغطاً أو طريقة دفع غير معتادة أو طلباً للوصول إلى حساباتك أو جهازك، فتوقّف وتحقّق عبر قناة تختارها أنت. وتحدّث إلى شخص تثق به قبل أن تتصرّف.',
    cta: 'ابدأ الفصل 5: الدفاع الرقمي عن النفس',
  },
}
